import { render } from "./StudentToOrgMatchingDataTable.vue?vue&type=template&id=1bf3dcf6&scoped=true"
import script from "./StudentToOrgMatchingDataTable.vue?vue&type=script&lang=js"
export * from "./StudentToOrgMatchingDataTable.vue?vue&type=script&lang=js"

import "./StudentToOrgMatchingDataTable.vue?vue&type=style&index=0&id=1bf3dcf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf3dcf6"]])

export default __exports__